import React from "react";
import PropTypes from "prop-types";

const Buttons = ({ onClick, active, showAboutModal }) => (
  <div className="button-wrapper">
    <button onClick={() => onClick("dashboard")} className={active === "dashboard" ? "active" : ""}>
      Dashboard
    </button>
    <a href="/data-hub/utilities/utility-profiles" target="_blank" rel="noreferrer noopener">
      <button>
        All data
      </button>
    </a>
    <button onClick={showAboutModal}>
      About this data
    </button>
    <button onClick={() => onClick("downloads")} className={active === "downloads" ? "active" : ""}>
      Download this data
    </button>
    <a href="https://www.gwiwaterdata.com/static_file_containers/390" target="_blank" rel="noreferrer noopener">
      <button>
        Download utility net-zero targets
      </button>
    </a>
  </div>
);

Buttons.propTypes = {
  onClick: PropTypes.func.isRequired,
  showAboutModal: PropTypes.func.isRequired,
  active: PropTypes.string.isRequired,
};

export default Buttons;
